module.exports = __webpack_public_path__ + "static/tech_arch_overview-0855164ea007ba3d980a6ab1f0b809b9.svg";